import { render, staticRenderFns } from "./balance-refund.vue?vue&type=template&id=4da853b4&scoped=true"
import script from "./balance-refund.vue?vue&type=script&lang=ts"
export * from "./balance-refund.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da853b4",
  null
  
)

export default component.exports